import Layout from '@/views/Layout';

// 权限管理
/**
 * !!! 注意
 * 【route name】将用于菜单权限配置相关, 所以不要轻易改动name;
 * 如必要修改，请同步更新role相关菜单配置，以及通知服务端做相关更新（如有）；
 */

export default {
  name: 'SysManage',
  path: '/sys-manage',
  meta: {
    icon: 'el-icon-setting',
    label: '系统管理',
    isMenu: true,
  },
  component: Layout,
  children: [
    {
      name: 'SysManageRole',
      path: 'role',
      component: () => import('@/views/SysManage/Role/Index'),
      meta: {
        label: '角色管理',
        isMenu: true,
      },
    },
    {
      name: 'SysManageUser',
      path: 'user',
      component: () => import('@/views/SysManage/User'),
      meta: {
        label: '用户管理',
        isMenu: true,
      },
    },
    {
      name: 'SysManagePerm',
      path: 'perm',
      component: () => import('@/views/SysManage/Perm/'),
      meta: {
        label: '权限管理',
        isMenu: true,
      },
    },
    {
      name: 'Amis',
      path: 'amis',
      component: () => import('@/views/Amis'),
      meta: {
        label: 'AMIS',
        isMenu: true,
        amisPath: 'amis',
      },
    },
    {
      name: 'Log',
      path: 'log',
      component: () => import('@/views/Log'),
      meta: {
        label: '日志',
        isMenu: true,
      },
    },
  ],
};
